import { render, staticRenderFns } from "./HomeLanding.vue?vue&type=template&id=5cc601e5&scoped=true&"
import script from "./HomeLanding.vue?vue&type=script&lang=js&"
export * from "./HomeLanding.vue?vue&type=script&lang=js&"
import style0 from "./HomeLanding.vue?vue&type=style&index=0&id=5cc601e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc601e5",
  null
  
)

export default component.exports